// @flow
import React from 'react'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Authors } from '../Authors'
import './styles.scss'

/*
// FOR VIDEO HEADER
const intro = require('../../videos/header-desktop.mp4')
const introMobile = require('../../videos/header-mobile.mp4')
const poster = require('../../images/cover-desktop.jpg')
const posterMobile = require('../../images/cover-mobile.jpg')
*/

const isMobile = window.innerWidth < 711
const isIOS9 = /iPhone OS [6789]_/.test(navigator.userAgent)

export class Header extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='header'>

      {/*
      // Video Header
      {!isIOS9 && (
        <video
          autoPlay
          muted
          playsInline
          preload
          loop
          poster={browserCheck.isMobile ? posterMobile : poster}
          ref={video => {
            if (video) {
              video.setAttribute('playsinline', '')
            }
          }}
        >
          {!browserCheck.isMobile && <source src={intro} type='video/mp4' />}
          {browserCheck.isMobile && <source src={introMobile} type='video/mp4' />}
        </video>
      )}
      {isIOS9 && <img src={poster} alt='' className='fallback' />}
      */}


      {/* Image Header */}
      <img className='header-image' src={require(this.state.isMobile ? '../../images/header-mobile.png' : '../../images/header-desktop.png')} alt='header' />
      
        <div className='title-wrapper'>
          <div className='titles'>
            <h1 dangerouslySetInnerHTML={{__html: this.props.title}}></h1>
          </div>
          <h2>{this.props.lead}</h2>
        </div>

        <div className="authors">
            <Authors authors={[
              {name: 'Marius Aschwanden', unityID:'82372634'},
              {name: 'Cedric Fröhlich', unityID:'63919784'},
              {name: 'Simon Wälti', unityID:'57616943'},
              {name: 'Christoph Hämmann', unityID:'31000657'},
              {name: 'Adrian Horn', unityID:'58851518'},
              {name: 'Martin Burkhalter', unityID:'96638818'},
              {name: 'Martina Hunziker', unityID:'72356363'},
              {name: 'Lena Rittmeyer', unityID:'82863413'},
              {name: 'Michael Feller', unityID:'76590909'},
              {name: 'Claudia Salzmann', unityID:'74237186'},
              {name: 'Jessica King', unityID:'38000052'},
              {name: 'Adrian Hopf-Sulc', unityID:'52888744'},
              {name: 'Mathias Lutz', unityID:'95724327'},
            ]}
            tenant={this.props.tenant} />
          </div>

    </div>
  }
}
